<template>
  <div v-if="card" class="bg-white rounded-lg border border-gray-200 overflow-hidden">
    <div class="px-4 py-3 border-b border-gray-200">
      <h3 class="text-sm font-semibold text-gray-900">Part B Drug Spending</h3>
    </div>
    <div class="p-4 space-y-4">
      <div v-for="section in card.sections.filter(s => s.type === 'metric')" :key="section.label" class="text-center">
        <div class="text-2xl font-semibold text-gray-900">{{ section.value }}</div>
        <div class="text-xs text-gray-500">{{ section.label }}</div>
      </div>
      <div v-for="section in card.sections.filter(s => s.type === 'key_value_grid')" :key="section.title" class="grid grid-cols-3 gap-2">
        <div v-for="item in section.items" :key="item.label" class="bg-gray-50 rounded p-2">
          <div class="text-xs text-gray-500">{{ item.label }}</div>
          <div class="text-sm font-medium text-gray-900">{{ item.value }}</div>
        </div>
      </div>
      <div v-for="section in card.sections.filter(s => s.type === 'table')" :key="section.title">
        <div class="text-xs font-medium text-gray-500 uppercase mb-2">Top Drugs</div>
        <table class="min-w-full text-sm">
          <thead>
            <tr class="text-left text-xs text-gray-500 uppercase border-b border-gray-200">
              <th v-for="col in section.columns" :key="col" class="pb-1 pr-3">{{ col }}</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(row, i) in section.rows" :key="i" class="border-b border-gray-200">
              <td v-for="(cell, j) in row" :key="j" class="py-1 pr-3">{{ cell }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PracticeDrugPrescribing',
  props: {
    insights: { type: Object, default: null },
  },
  computed: {
    card() {
      if (!this.insights?.cards) return null
      return this.insights.cards.find(c => c.id === 'drug_prescribing' && c.available)
    },
  },
}
</script>
